import React, { useEffect, useState } from 'react'
import { Table, Col, Row, Card, message } from 'antd'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import inventorySrc from '../../inventorySrc'
import Utils from '../../../../utils/Utils'

function DownloadTable(props) {
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [nextPage, setNextPage] = useState('')
  const [existMoreInfo, setExistMoreInfo] = useState(false)

  useEffect(() => {    
    const paginate = !!props.searchText || props.searchText === ''
    if (!props.keyTab || props.keyTab === '6') fetchInventory(paginate, props.searchText)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedOption, props.searchText, props.keyTab, props.lowStock])

  const fetchInventory = (paginate, filter = '', lowStock=false) => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(filter)
    inventorySrc
      .getStockOptions(props.selectedOption, paginate, filter, props.lowStock, excludeChars, 'desc')
      .then(res => {
        if (res?.errors && Object.keys(res.errors)?.length > 0) {
          Utils.checkErrors(res)
          setLoading(false)
        } else {
          setDataSource(setInventory(res))
          setExistMoreInfo(res.data.next_page_url !== null)
          setNextPage(res.data.next_page_url)
          setLoading(false)
        }
      })
      .catch(e => {
        message.error('No se ha podido cargar el inventario.')
        setLoading(false)
      })
  }

  const columns = [
    {
      title: 'Producto',
      dataIndex: 'product', // Field that is goint to be rendered
      key: 'product',
      render: text => <span style={{ textAlign: 'left' }}>{text ? text : 'Sin nombre'}</span>,
    },
    {
      title: 'Cantidad',
      dataIndex: 'quantity', // Field that is goint to be rendered
      key: 'quantity',
      render: text => <span>{text ? text : 'Sin cantidad'}</span>,
    },
    {
      title: 'Costo promedio unitario',
      dataIndex: 'avg_product_unit_cost', // Field that is goint to be rendered
      key: 'avg_product_unit_cost',
      render: text => <span>{text ? text : 'Sin salida'}</span>,
    },    
  ]

  const handlerMoreButton = () => {
    setExistMoreInfo(false)
    if (existMoreInfo) {
      setLoading(true)
      inventorySrc.getNextPage(nextPage).then(response => {
        setDataSource(dataSource.concat(setInventory(response)))
        setExistMoreInfo(response.data.next_page_url !== null)
        setNextPage(response.data.next_page_url)
        setLoading(false)
      })
    }
  }

  const setInventory = inventory => {
    if (inventory !== 'Too Many Attempts.') {
      let _inventory = inventory.data.data || []

      return _inventory.map((d, i) => ({
        key: i,
        avg_product_unit_cost: d.avg_product_unit_cost,
        product: d.product.description,
        quantity: d.quantity,
        store: d.store.name
      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card className={'card-border-radius'}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Table className={'CustomTableClass'} dataSource={dataSource} columns={columns} pagination={false} loading={loading} rowKey="key" />
                <LoadMoreButton handlerButton={handlerMoreButton} moreInfo={existMoreInfo} />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default DownloadTable
